import { MobileHistoryDateRowStyled } from './styled/MobileHistoryDateRowStyled';
import { memo } from 'react';
import { IMobileHistoryDateRow } from '../mobileHistory.t';
import classNames from 'classnames';

interface IMobileHistoryDateRowProps {
    index: number,
    item: IMobileHistoryDateRow,
}

function MobileHistoryDateRow(props: IMobileHistoryDateRowProps) {
    const { index, item } = props;
    return <MobileHistoryDateRowStyled className={classNames('mobile-history-date-row', {
        first: index === 0,
    })}>
        {item.formattedDate}
    </MobileHistoryDateRowStyled>;
}

export default memo(MobileHistoryDateRow);
